// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3JOfW","insightsList":"newBusinessInsightsMenu_insightsList__2p9jP","active":"newBusinessInsightsMenu_active__2W3SM"};